import { MarketplaceItem } from '../../marketplace/models/marketplace-item.model';
import { LottoItem } from '../../lotto/models/lotto-item.model';
import { AuctionItem } from '../../auction/models/auction-item.model';
import { LoyaltyStatus } from './loyalty-status.model';

export class MixedLoyaltyItem {
  type: 'auction' | 'marketplace' | 'lotto';
  data: AuctionItem | MarketplaceItem | LottoItem | any;
  status: LoyaltyStatus;

  constructor(o?: Partial<MixedLoyaltyItem>) {
    o = o || {};
    this.type = o.type || 'auction';
    this.data = o.data || {};
    this.status = o.status || new LoyaltyStatus();
  }

}
